module.exports = __webpack_public_path__ + "fonts/Comicv3b.25b0d235.ttf";